/** @jsxImportSource @emotion/react */
import { object, number, func } from 'prop-types';
import { css } from '@emotion/react';
import { useTokens, TextStyled, IconButton } from '@nike/nike-design-system-components';
import { Delete, Edit } from '@nike/nike-design-system-icons';

import LineItemAttribute from './LineItemAttribute';
import ProductImage from '../../../components/aurora/ProductImage';

const LineItem = ({ item, index, handleDeleteItem, handleEditItem }) => {
  const tokens = useTokens();

  return (
    <div
      key={item.id}
      css={css`
        padding: 12px;
        border: 1px solid ${tokens.podiumCdsColorGrey300};
        width: calc(50% - 8px);

        @media (max-width: 768px) {
          width: 100%;
        }
      `}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div style={{ maxWidth: '75%' }}>
          <TextStyled appearance='body2Strong'>Item {index + 1}</TextStyled>
          <div style={{ padding: '0 20px' }}>
            <LineItemAttribute attributeName='Product Code' value={item.productCode} />
            <LineItemAttribute attributeName='Product Name' value={item.productName} />
            <LineItemAttribute attributeName='Color' value={item.colorName} />
          </div>
          <div style={{ padding: '5px 20px' }}>
            <TextStyled appearance='body2Strong'>Sizes:</TextStyled>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                border: `1px solid ${tokens.podiumCdsColorGrey300}`,
                borderRadius: '4px',
                marginTop: '8px'
              }}
            >
              <div style={{ display: 'flex', background: tokens.podiumCdsColorGrey100, textAlign: 'center' }}>
                <div
                  style={{
                    flex: 1,
                    borderRight: `1px solid ${tokens.podiumCdsColorGrey300}`,
                    padding: '4px 8px'
                  }}
                >
                  <TextStyled appearance='body2Strong'>Size Code</TextStyled>
                </div>
                <div style={{ flex: 1, padding: '4px 8px', width: '25px' }}>
                  <TextStyled appearance='body2Strong'>Quantity</TextStyled>
                </div>
              </div>
              {item.sizes.map(size => (
                <div
                  key={size.id}
                  style={{
                    display: 'flex',
                    borderTop: `1px solid ${tokens.podiumCdsColorGrey300}`,
                    textAlign: 'center'
                  }}
                >
                  <div
                    style={{
                      flex: 1,
                      borderRight: `1px solid ${tokens.podiumCdsColorGrey300}`,
                      padding: '4px 8px'
                    }}
                  >
                    <TextStyled appearance='body2'>{size.sizeCode}</TextStyled>
                  </div>
                  <div style={{ flex: 1, padding: '4px 8px' }}>
                    <TextStyled appearance='body2'>{size.quantity}</TextStyled>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', marginRight: '10px' }}>
          <ProductImage productCode={item.productCode} alt={item.productName} width={100} height={100} />
          <div style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: '10px' }}>
            <IconButton Icon={<Delete />} appearance='secondary' size='small' onClick={() => handleDeleteItem(item)} />
            {item.isManual === false && (
              <IconButton Icon={<Edit />} appearance='secondary' size='small' onClick={() => handleEditItem(item)} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

LineItem.propTypes = {
  item: object.isRequired,
  index: number.isRequired,
  handleDeleteItem: func.isRequired,
  handleEditItem: func.isRequired
};

export default LineItem;
